import { useEffect, useState } from "react";

import * as C from "./Order.styles";

import ErrorPopup from "../ErrorPopup/ErrorPopup";

const Order = ({ pizza, onClose, onSave, isOpen, pizzas }) => {
    const [error, setError] = useState(false);
    const [errorMessage, setErrorMessage] = useState("Algo deu errado!");
    const [size, setSize] = useState("");
    const [pizzaBorder, setPizzaBorder] = useState("");
    const [portion, setPortion] = useState("");
    const [additionalPizza, setAdditionalPizza] = useState(null);
    const [itensCombo, setItensCombo] = useState({
        pizza1G: "",
        pizza2G: "",
        pizza1P: ""
    })
    const [extras, setExtras] = useState([]);
    const [observations, setObservations] = useState("");
    const [selectedFlavors, setSelectedFlavors] = useState([]);

    useEffect(() => {
        if (isOpen) {
            document.body.style.overflow = "hidden";
        } else {
            document.body.style.overflow = "";
        }
        return () => {
            document.body.style.overflow = "";
        };
    }, [isOpen]);

    const PIZZA_CONFIGS = {
        "tradicional/meioMetro": { 
            maxFlavors: 3, 
            allowedTypes: ["tradicionais", "doces"],
            sizeName: "Meio Metro",
            orderType: "meio metro"
        },
        "especial/meioMetro": { 
            maxFlavors: 3, 
            allowedTypes: ["especiais", "doces"],
            sizeName: "Meio Metro", 
            orderType: "meio metro"
        },
        "tradicional/familia": { 
            maxFlavors: 4, 
            allowedTypes: ["tradicionais", "doces"],
            sizeName: "Família",
            orderType: "familia"
        },
        "especial/familia": { 
            maxFlavors: 4, 
            allowedTypes: ["especiais", "doces"],
            sizeName: "Família",
            orderType: "familia"
        }
    };

    const getPizzaConfig = (tipo) => PIZZA_CONFIGS[tipo] || null;
    const isMultiFlavorPizza = (tipo) => Boolean(getPizzaConfig(tipo));
    const getAvailablePizzas = (allowedTypes) => 
        allowedTypes.reduce((acc, type) => {
            const filteredPizzas = pizzas[type].filter(p => !p.tipo.includes("/"));
            return [...acc, ...filteredPizzas];
        }, []);

    const getFlavorSelectionText = (maxFlavors, currentCount) => {
        const texts = {
            3: "Escolha até 3 sabores",
            4: `Escolha até 4 sabores (${currentCount}/4 selecionados)`
        };
        return texts[maxFlavors] || "Escolha os sabores";
    };

    const buildPizzaName = (config, flavors) => {
        const flavorText = flavors.length === 1 
            ? flavors[0] 
            : flavors.join(" + ");
        return `Pizza ${config.sizeName} de ${flavorText}`;
    };

    const handleToggleFlavor = (flavor) => {
        const config = getPizzaConfig(pizza.tipo);
        if (!config) return;
        
        if (selectedFlavors.includes(flavor)) {
            setSelectedFlavors(selectedFlavors.filter(f => f !== flavor));
        } else {
            if (selectedFlavors.length < config.maxFlavors) {
                setSelectedFlavors([...selectedFlavors, flavor]);
            }
        }
    };

    const handleToggleExtra = (extra) => {
        if (pizzas.adicionaisDoce.includes(extra)) {
            if (extras.includes(extra)) {
                setExtras(extras.filter(item => item !== extra));
            } else {
                setExtras([extra]);
            }
        } else {
            if (extras.includes(extra)) {
                setExtras(extras.filter(item => item !== extra));
            } else {
                setExtras([...extras, extra]);
            }
        }
    };

    const handleSave = () => {
        if (pizza.tipo === "combo") {
            if (pizza.opcoes === "tradicionais") {
                if (itensCombo.pizza1G !== "" && itensCombo.pizza2G !== "" && itensCombo.pizza1P !== "") {
                    const orderDetails = {
                        pizza: itensCombo,
                        ingredientes: "",
                        price: pizza.valor,
                        size: "",
                        portion: "",
                        pizzaBorder: "",
                        additionalPizza: null,
                        extras: [],
                        observations: observations,
                        tipo: "combo"
                    };
                    onSave(orderDetails);
                    onClose();
                } else {
                    setErrorMessage("Você precisa escolher os 3 sabores de pizza para prosseguir");
                    setError(true);
                    return;
                }
            } else {
                if (itensCombo.pizza1G !== "" && itensCombo.pizza1P !== "") {
                    const orderDetails = {
                        pizza: itensCombo,
                        ingredientes: "",
                        price: pizza.valor,
                        size: "",
                        portion: "",
                        pizzaBorder: "",
                        additionalPizza: null,
                        extras: [],
                        observations: observations,
                        tipo: "combo"
                    };
                    onSave(orderDetails);
                    onClose();
                } else {
                    setErrorMessage("Você precisa escolher os 2 sabores de pizza para prosseguir");
                    setError(true);
                    return;
                }
            }
        } else if (isMultiFlavorPizza(pizza.tipo)) {
            const config = getPizzaConfig(pizza.tipo);
            
            if (selectedFlavors.length === 0) {
                setErrorMessage("Você precisa escolher pelo menos 1 sabor de pizza para prosseguir");
                setError(true);
                return;
            }

            const nomePizza = buildPizzaName(config, selectedFlavors);

            const orderDetails = {
                pizza: nomePizza,
                ingredientes: "",
                price: pizza.valor,
                size: "G",
                portion: "inteira",
                pizzaBorder,
                additionalPizza: '',
                extras,
                observations,
                tipo: config.orderType
            };

            onSave(orderDetails);
            onClose();
        } else {
            if (size === "" && pizza.tipo.split('/').length === 1) {
                setErrorMessage("Escolha o tamanho da pizza (P ou G) para prosseguir");
                setError(true);
                return;
            }
            if (size === "G" && portion === "") {
                setErrorMessage("Escolha o tipo de porção (inteira ou meia) para prosseguir");
                setError(true);
                return;
            }
            if (size === "G" && portion === "Meia" && additionalPizza === null) {
                setErrorMessage("Escolha a outra metade da pizza ou mude para inteira para prosseguir");
                setError(true);
                return;
            }

            let valorPizza = pizza.valor;
            if (pizza.tipo === "tradicional" && size === "P") {
                valorPizza = 40;
            }
            if (pizza.tipo === "doce" && size === "P") {
                valorPizza = 40;
            }
            if (pizza.tipo === "especial" && size === "P") {
                valorPizza = 50;
            }

            const orderDetails = {
                pizza: pizza.nome,
                ingredientes: pizza.ingredientes,
                price: valorPizza,
                size,
                portion: size === "P" ? "Inteira" : portion,
                pizzaBorder,
                additionalPizza: portion === "Meia" ? additionalPizza : null,
                extras,
                observations,
            };

            onSave(orderDetails);
            onClose();
        }
    };

    return (
        <C.Background isOpen={!!pizza} >
            {error && <ErrorPopup isOpen={error} message={errorMessage} onClose={() => setError(false)} />}
            <C.OrderFormContainer>
                <C.PopupHeader>
                    <span>{pizza?.nome}</span>
                    <button onClick={onClose}>x</button>
                </C.PopupHeader>
                {
                    pizza.tipo === "combo" ?
                        <C.PopupBody>
                            <C.Select>
                                <label>01 - Pizza G</label>
                                <select
                                    value={itensCombo.pizza1G || ""}
                                    onChange={(e) =>
                                        setItensCombo((prev) => ({ ...prev, pizza1G: e.target.value }))
                                    }
                                >
                                    <option value="">Selecione</option>
                                    {[
                                        ...(pizza.opcoes === "especiais" 
                                            ? pizzas.especiais.filter(p => !p.tipo.includes("/"))
                                            : pizzas.tradicionais.filter(p => p.combo && !p.tipo.includes("/"))),
                                        ...pizzas.doces,
                                    ].map((p) => (
                                        <option key={p.nome} value={p.nome === "Chocolate ao leite" ? `${p.nome} + Granulado` : p.nome}>
                                            {p.nome === "Chocolate ao leite" ? `${p.nome} + Granulado` : p.nome}
                                        </option>
                                    ))}
                                </select>
                            </C.Select>

                            {pizza.opcoes !== "especiais" &&
                                <C.Select>
                                    <label>02 - Pizza G</label>
                                    <select
                                        value={itensCombo.pizza2G || ""}
                                        onChange={(e) =>
                                            setItensCombo((prev) => ({ ...prev, pizza2G: e.target.value }))
                                        }
                                    >
                                        <option value="">Selecione</option>
                                        {[...pizzas.tradicionais.filter(p => p.combo && !p.tipo.includes("/")), ...pizzas.doces].map((p) => (
                                            <option key={p.nome} value={p.nome === "Chocolate ao leite" ? `${p.nome} + Granulado` : p.nome}>
                                                {p.nome === "Chocolate ao leite" ? `${p.nome} + Granulado` : p.nome}
                                            </option>
                                        ))}
                                    </select>
                                </C.Select>
                            }

                            <C.Select>
                                <label>{pizza.opcoes === "especiais" ? "02" : "03"} - Pizza P</label>
                                <select
                                    value={itensCombo.pizza1P || ""}
                                    onChange={(e) =>
                                        setItensCombo((prev) => ({ ...prev, pizza1P: e.target.value }))
                                    }
                                >
                                    <option value="">Selecione</option>
                                    {[
                                        ...(pizza.opcoes === "especiais" 
                                            ? pizzas.especiais.filter(p => !p.tipo.includes("/"))
                                            : pizzas.tradicionais.filter(p => p.combo && !p.tipo.includes("/"))),
                                        ...pizzas.doces,
                                    ].map((p) => (
                                        <option key={p.nome} value={p.nome === "Chocolate ao leite" ? `${p.nome} + Granulado` : p.nome}>
                                            {p.nome === "Chocolate ao leite" ? `${p.nome} + Granulado` : p.nome}
                                        </option>
                                    ))}
                                </select>
                            </C.Select>

                            {/* Observações */}
                            <C.Observations>
                                <label>Observações:</label>
                                <textarea
                                    value={observations}
                                    onChange={(e) => setObservations(e.target.value)}
                                    placeholder="Ex.: Sem cebola na pizza 1, ..."
                                />
                            </C.Observations>
                            {/* Botões */}
                            <C.PopupFooter>
                                <button onClick={handleSave}>Finalizar</button>
                                <button onClick={onClose}>Cancelar</button>
                            </C.PopupFooter>
                        </C.PopupBody>
                        :
                        isMultiFlavorPizza(pizza.tipo) ?
                            <C.PopupBody>
                                <C.Section>
                                    <span>Tamanho da Pizza</span>
                                    <div>
                                        <div>
                                            <input type="radio" value="G" checked={true} readOnly />
                                            <span>{getPizzaConfig(pizza.tipo)?.sizeName}</span>
                                        </div>
                                    </div>
                                </C.Section>

                                <C.SectionExtras>
                                    <label style={{ color: "#FF0000" }}>
                                        {(() => {
                                            const config = getPizzaConfig(pizza.tipo);
                                            return getFlavorSelectionText(config?.maxFlavors, selectedFlavors.length);
                                        })()}
                                    </label>
                                    {(() => {
                                        const config = getPizzaConfig(pizza.tipo);
                                        return getAvailablePizzas(config?.allowedTypes || []);
                                    })().map((p) =>
                                        pizza.nome !== p.nome ? (
                                            <div key={p.nome}>
                                                <label>
                                                    <div>
                                                        <input
                                                            type="checkbox"
                                                            checked={selectedFlavors.includes(p.nome)}
                                                            onChange={() => handleToggleFlavor(p.nome)}
                                                            disabled={
                                                                !selectedFlavors.includes(p.nome) &&
                                                                selectedFlavors.length >= (getPizzaConfig(pizza.tipo)?.maxFlavors || 0)
                                                            }
                                                        />
                                                        <span>{p.nome}</span>
                                                    </div>
                                                </label>
                                            </div>
                                        ) : null
                                    )}
                                </C.SectionExtras>

                                {/* Borda */}
                                <C.Section>
                                    <span>Escolha sua borda</span>
                                    <div>
                                        <div>
                                            <input
                                                type="radio"
                                                value="Catupiry"
                                                checked={pizzaBorder === "Catupiry"}
                                                onChange={() => setPizzaBorder("Catupiry")}
                                            />
                                            <span>Catupiry</span>
                                        </div>
                                        <div>
                                            <input
                                                type="radio"
                                                value="Cheddar"
                                                checked={pizzaBorder === "Cheddar"}
                                                onChange={() => setPizzaBorder("Cheddar")}
                                            />
                                            <span>Cheddar</span>
                                        </div>
                                        <div>
                                            <input
                                                type="radio"
                                                value="Sem Borda"
                                                checked={pizzaBorder === "Sem Borda"}
                                                onChange={() => setPizzaBorder("Sem Borda")}
                                            />
                                            <span>Sem Borda</span>
                                        </div>
                                    </div>
                                </C.Section>

                                {/* Adicionais */}
                                <C.SectionExtras>
                                    <label>Adicionais:</label>
                                    {pizzas.adicionais.map((extra) => (
                                        <div key={extra.nome}>
                                            <label>
                                                <div>
                                                    <input
                                                        type="checkbox"
                                                        checked={extras.includes(extra)}
                                                        onChange={() => handleToggleExtra(extra)}
                                                    />
                                                    <span>{extra.nome}</span>
                                                </div>
                                                <span>R$ {extra.valor},00</span>
                                            </label>
                                        </div>
                                    ))}
                                </C.SectionExtras>

                                {/* Observações */}
                                <C.Observations>
                                    <label>Observações:</label>
                                    <textarea
                                        value={observations}
                                        onChange={(e) => setObservations(e.target.value)}
                                        placeholder="Ex.: Sem cebola, pouco queijo..."
                                    />
                                </C.Observations>

                                <C.PopupFooter>
                                    <button onClick={handleSave}>Finalizar</button>
                                    <button onClick={onClose}>Cancelar</button>
                                </C.PopupFooter>
                            </C.PopupBody>
                            :
                            <C.PopupBody>
                                {/* Tamanho da Pizza */}
                                <C.Section>
                                    <span>Tamanho da Pizza</span>

                                    <div>
                                        <div>
                                            <input
                                                type="radio"
                                                value="P"
                                                checked={size === "P"}
                                                onChange={() => setSize("P")}
                                            />
                                            <span>P</span>
                                        </div>
                                        <div>
                                            <input
                                                type="radio"
                                                value="G"
                                                checked={size === "G"}
                                                onChange={() => setSize("G")}
                                            />
                                            <span>G</span>
                                        </div>
                                    </div>
                                </C.Section>

                                {/* Borda */}
                                {size === "G" && pizza.tipo !== "doce" &&
                                    <C.Section>
                                        <span>Escolha sua borda</span>

                                        <div>
                                            {(pizza.tipo === "tradicional" || pizza.tipo === "especial") &&
                                                <div>
                                                    <input
                                                        type="radio"
                                                        value="Catupiry"
                                                        checked={pizzaBorder === "Catupiry"}
                                                        onChange={() => setPizzaBorder("Catupiry")}
                                                    />
                                                    <span>Catupiry</span>
                                                </div>}
                                            {(pizza.tipo === "tradicional" || pizza.tipo === "especial") &&
                                                <div>
                                                    <input
                                                        type="radio"
                                                        value="Cheddar"
                                                        checked={pizzaBorder === "Cheddar"}
                                                        onChange={() => setPizzaBorder("Cheddar")}
                                                    />
                                                    <span>Cheddar</span>
                                                </div>}
                                            {(pizza.tipo === "tradicional" || pizza.tipo === "especial") &&
                                                <div>
                                                    <input
                                                        type="radio"
                                                        value="Sem Borda"
                                                        checked={pizzaBorder === "Sem Borda"}
                                                        onChange={() => setPizzaBorder("Sem Borda")}
                                                    />
                                                    <span>Sem Borda</span>
                                                </div>}
                                        </div>
                                    </C.Section>
                                }

                                {/* Porção (Meia ou inteira) */}
                                {
                                    size !== "" && size !== "P" &&
                                    <C.Section>
                                        <span>Opção da Pizza</span>

                                        <div>
                                            <div>
                                                <input
                                                    type="radio"
                                                    value="Inteira"
                                                    checked={portion === "Inteira"}
                                                    onChange={() => { setPortion("Inteira"); setAdditionalPizza(null); setExtras([]) }}
                                                />
                                                <span>Inteira</span>
                                            </div>
                                            <div>
                                                <input
                                                    type="radio"
                                                    value="Meia"
                                                    checked={portion === "Meia"}
                                                    onChange={() => { setPortion("Meia"); setAdditionalPizza(null); setExtras([]) }}
                                                />
                                                <span>Meia</span>
                                            </div>
                                        </div>
                                    </C.Section>

                                }

                                {portion === "Meia" && (
                                    <C.Select>
                                        <label style={{ color: "#FF0000" }}>Outra metade</label>
                                        <select
                                            value={additionalPizza || ""}
                                            onChange={(e) => setAdditionalPizza(e.target.value)}
                                        >
                                            <option value="">Selecione</option>
                                            {pizza.tipo === "doce" || pizza.tipo === "tradicional" ? (
                                                [...pizzas.tradicionais, ...pizzas.doces]
                                                    .filter(p => !p.tipo.includes("/"))
                                                    .map((p) =>
                                                        pizza.nome !== p.nome ? (
                                                            <option key={p.nome} value={p.nome}>
                                                                {p.nome}
                                                            </option>
                                                        ) : null
                                                    )
                                            ) : (
                                                pizzas.especiais
                                                    .filter(p => !p.tipo.includes("/"))
                                                    .map((p) =>
                                                    pizza.nome !== p.nome ? (
                                                        <option key={p.nome} value={p.nome}>
                                                            {p.nome}
                                                        </option>
                                                    ) : null
                                                )
                                            )}
                                        </select>
                                    </C.Select>
                                )}

                                {/* Adicionais */}
                                {
                                    (pizza.tipo !== "doce" || (additionalPizza !== null && additionalPizza !== "" && additionalPizza !== "Prestígio" && additionalPizza !== "Choconfete" && additionalPizza !== "Brigadeiro" && additionalPizza !== "Romeu e Julieta")) &&
                                    <C.SectionExtras>
                                        <label>Adicionais:</label>
                                        {
                                            pizzas.adicionais.map((extra) => (
                                                <div key={extra.nome}>
                                                    <label>
                                                        <div>
                                                            <input
                                                                type="checkbox"
                                                                checked={extras.includes(extra)}
                                                                onChange={() => handleToggleExtra(extra)}
                                                            />
                                                            <span>{extra.nome}</span>
                                                        </div>
                                                        <span>R$ {extra.valor},00</span>
                                                    </label>
                                                </div>
                                            ))
                                        }
                                    </C.SectionExtras>
                                }

                                {/* Observações */}
                                <C.Observations>
                                    <label>Observações:</label>
                                    <textarea
                                        value={observations}
                                        onChange={(e) => setObservations(e.target.value)}
                                        placeholder="Ex.: Sem cebola, pouco queijo..."
                                    />
                                </C.Observations>

                                {/* Botões */}
                                <C.PopupFooter>
                                    <button onClick={handleSave}>Finalizar</button>
                                    <button onClick={onClose}>Cancelar</button>
                                </C.PopupFooter>
                            </C.PopupBody>
                }
            </C.OrderFormContainer>
        </C.Background>
    );
};

export default Order;